import { FaCircle } from 'react-icons/fa'
import React from 'react'
import css from './PortDepartures.module.css'

interface FirstColumnProps {
  data: string
  showIcon: boolean
  showFreeSell?: boolean
}
const FirstColumn: React.FC<FirstColumnProps> = ({ data, showIcon, showFreeSell }) => {
  return (
    <span>
      {data}
      {(showFreeSell || showIcon) && (
        <span className={css.iconsContainer}>
          {showFreeSell && <FaCircle className={css.green} />}
          {showIcon && <FaCircle />}
        </span>
      )}
    </span>
  )
}
export default FirstColumn
